/**
 * ч.1139: стани перенесення з 1С і моделі перенесення — людською мовою.
 * Одні й ті самі слова в майстрі міграції та в «Історії міграцій»
 * (раніше обидві сторінки показували код: IMPORTING, full_clone).
 */

/** Стан перенесення — як його бачить бухгалтер. */
export const RUN_STATUS_LABELS: Record<string, string> = {
  WIZARD_IN_PROGRESS: 'налаштування',
  READY: 'очікує даних з 1С',
  IMPORTING: 'прийом даних',
  BULK_POSTING: 'проведення документів',
  VALIDATING: 'перевірка',
  COMPLETED: 'завершено',
  FAILED: 'помилка',
  ROLLED_BACK: 'повернуто в 1С',
};

export function runStatusLabel(status: string | null | undefined): string {
  return (status && RUN_STATUS_LABELS[status]) || 'невідомий стан';
}

/** Модель перенесення (старі назви лишились у перенесеннях до 2026-07). */
export const PROFILE_LABELS: Record<string, string> = {
  full_clone: 'Повний клон',
  deep_history: 'Глибока історія — 5 років',
  working_year: 'Робочий рік',
  clean_start: 'Чистий старт — лише залишки',
  custom: 'Власні налаштування',
  small_business: 'Малий бізнес',
  medium_business: 'Середній бізнес',
  enterprise: 'Велике підприємство',
};

export function profileLabel(profile: string | null | undefined): string {
  return (profile && PROFILE_LABELS[profile]) || 'Власні налаштування';
}

/** Дата YYYY-MM-DD → дд.мм.рррр (без зсуву часового поясу). */
export function runDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}.${m}.${y}`;
}
